export const FIND_CHAT_CONVERSATION_PARTNERS_FAILURE = 'FIND_CHAT_CONVERSATION_PARTNERS_FAILURE';

export const findChatConversationPartnersFailure = error => ({
    type: FIND_CHAT_CONVERSATION_PARTNERS_FAILURE,
    payload: error,
    error: true,
});
